var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"},attrs:{"id":"content"}},[_c('canvas',{ref:"canvas",staticStyle:{"width":"1000px","height":"600px"},attrs:{"id":"canvas"}})])}
var staticRenderFns = []

export { render, staticRenderFns }